import { fechaCelda, haceCelda } from '../../../auxiliares/tabla/celdas';

/**
 * Fecha de un log para una celda `html`: en los logs los segundos importan
 * (orden de los frames, reintentos), así que van en la celda además de
 * "hace x". Mismo formato que `fechaCelda` (24 h, huso del navegador).
 */
export function fechaLogHtml(v: string | Date | undefined | null): string {
  const base = fechaCelda(v);
  if (!base) return '';
  const d = v instanceof Date ? v : new Date(v as string);
  const seg = String(d.getSeconds()).padStart(2, '0');
  return (
    `<span class="tabla-fecha"><span>${base}:${seg}</span>` +
    `<span class="tabla-secundario">${haceCelda(v)}</span></span>`
  );
}
